export default "__VITE_ASSET__DEpbVArs__"